module.exports = __webpack_public_path__ + "img/icon-car.08087cf2.svg";